import React from 'react'
import { Stack, Box, Skeleton } from '@mui/material'

const PeriodWidgetSkeleton = () => {
  return (
    <Box
      sx={{
        width: { xs: '100%', sm: '50%', md: '15%' },
        border: '1px solid #EFEFEF',
        borderRadius: '16px',
        padding: 2,
        backgroundColor: '#F7F7F7',
        minHeight: '100px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Stack spacing={1.5} alignItems="center" sx={{ width: '100%' }}>
        <Stack spacing={0.5} alignItems="center">
          <Skeleton variant="circular" width={16} height={16} />
          <Skeleton variant="text" width={80} height={14} />
        </Stack>
        <Skeleton variant="rectangular" width={120} height={28} sx={{ borderRadius: 1 }} />
      </Stack>
    </Box>
  )
}

export default PeriodWidgetSkeleton